import ArrowDown from './arrow-down.svg';

export default {
  ArrowDown
};